import {
  ADD_GAME_ROLE,
  DESTROY_GAME_ROLE,
  UPDATE_GAME_ROLE,
} from '../constants/action-types'

export const addGameRole = (gameRoleData) => ({
  type: ADD_GAME_ROLE,
  payload: gameRoleData,
})

export const updateGameRole = (gameRoleData) => ({
  type: UPDATE_GAME_ROLE,
  payload: gameRoleData,
})

export const destroyGameRole = (gameRoleData) => ({
  type: DESTROY_GAME_ROLE,
  payload: gameRoleData,
})